import type { PlaylistItem } from '@jwp/ott-common/types/playlist';
import { CONTENT_TYPE } from '@jwp/ott-common/src/constants';
import { MediaStatus, getMediaStatusFromEventState } from '@jwp/ott-common/src/utils/liveEvent';

export { EventState, MediaStatus, getMediaStatusFromEventState } from '@jwp/ott-common/src/utils/liveEvent';
import { isLiveChannel } from '@jwp/ott-common/src/utils/media';

/**
 * True when playback should use live UI/streaming (no seek bar, live badge, etc.).
 * VCH events use `getMediaStatusFromEventState` so VOD_PUBLIC / INSTANT_VOD stay seekable.
 */
export function isLiveStreamPlayback(item: PlaylistItem): boolean {
  if (isLiveChannel(item)) return true;

  const contentType = item.contentType?.toLowerCase();
  if (contentType === CONTENT_TYPE.live || contentType === CONTENT_TYPE.liveChannel) return true;

  if (item['VCH.EventState']) {
    return getMediaStatusFromEventState(item) === MediaStatus.LIVE;
  }

  return item.mediaStatus === MediaStatus.LIVE;
}

/** @deprecated Prefer `isLiveStreamPlayback` — kept for existing imports. */
export function isLiveLikeItem(item: PlaylistItem): boolean {
  return isLiveStreamPlayback(item);
}

/** Above this, `HTMLMediaElement.duration` is usually a live / presentation-window artifact, not real VOD length. */
export const MAX_PLAUSIBLE_VOD_DURATION_SEC = 72 * 3600;

export function effectiveDurationForProgress(video: HTMLVideoElement, treatAsLive: boolean): number {
  if (treatAsLive) return -1;
  const d = video.duration;
  if (!Number.isFinite(d) || d <= 0 || d > MAX_PLAUSIBLE_VOD_DURATION_SEC) return -1;
  return d;
}
